import { mapState } from 'vuex';
import marketFiltersMixin from '@/components/market/market-filters/market-filters-mixin/market-filters-mixin';

export default {
  mixins: [
    marketFiltersMixin,
  ],
  computed: {
    ...mapState('watchlist', [
      'selectedOrder',
      'selectedTimespan',
      'shouldShowTimespanFilter',
    ]),
    mainClassName() {
      return 'market-filters-desktop-grid-watchlist';
    },
    menuClassModifier() {
      return {
        'market-filters-desktop-grid-watchlist__menu': true,
        'market-filters-desktop-grid-watchlist__menu--with-timespan-filter': this.shouldShowTimespanFilter,
      };
    },
    orderMenuName() {
      return this.selectedOrder.fullName;
    },
  },
  created() {
    this.isWatchlistOpen = true;
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-filters/market-filters-desktop-grid-watchlist/market-filters-desktop-grid-watchlist.js